module.exports = __webpack_public_path__ + "img/mobile_btn3.436afb3d.png";